import type { StandardSchemaV1 } from '@standard-schema/spec'
import type { InferProtocol, RouteOutput, ClientOptions, RouterClient } from './types.js'
import type { Capability } from './capability.js'

export function createClient<
  T extends InferProtocol<Record<string, RouteOutput<Capability<StandardSchemaV1>, unknown>>>
> (options:ClientOptions):RouterClient<T> {
    const { url, capabilities } = options

    // Create a map of capabilities by their `cmd` property
    const capabilityMap = Object.fromEntries(
        capabilities.map((cap) => [cap.cmd, cap])
    )
    return {
        request: async (cmd:string, args:any) => {
            const capability = capabilityMap[cmd]

            if (!capability) {
                throw new Error(`Capability not found: ${cmd}`)
            }

            const inv = await capability.invoke({
                args,
                iss: options.issuer,
                sub: options.audience.did,
                store: options.store,
                exp: null,
            })

            const response = await fetch(url, {
                method: 'POST',
                body: inv.bytes as BufferSource,
            })
            return response.json()
        },
    }
}
